const mergeReplacingArrays = (a, b) => {
  if (
    Array.isArray(a) ||
    typeof a !== 'object' ||
    a === null ||
    Array.isArray(b) ||
    typeof b !== 'object' ||
    b === null
  ) {
    return b
  }

  a = Object.assign({}, a)
  for (const prop in b) {
    a[prop] = mergeReplacingArrays(a[prop], b[prop])
  }

  return a
}

const multiMergeReplacingArrays = (...args) => {
  let accumulator = args.shift()
  for (const arg of args) {
    accumulator = mergeReplacingArrays(accumulator, arg)
  }

  return accumulator
}

module.exports = multiMergeReplacingArrays